"use client";

import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useRouter } from "next/navigation";

export default function PostSurveyAlertDialog() {
  const [open, setOpen] = React.useState(true);
  const router = useRouter();

  const handleClose = () => {
    setOpen(false);
  };

  const handlePostClose = () => {
    setOpen(false);
    router.push("/postsurvey");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {
          "Can you please complete the survey(s) for your previous YEX sessions?"
        }
      </DialogTitle>
      <DialogActions>
        <Button
          onClick={handlePostClose}
          autoFocus
          sx={{ color: "black", textTransform: "none" }}
        >
          Yes
        </Button>
        <Button
          onClick={handleClose}
          sx={{ color: "black", textTransform: "none" }}
        >
          No, Not at this time.
        </Button>
      </DialogActions>
    </Dialog>
  );
}
